"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
const cross_fetch_1 = require("cross-fetch");
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
class HttpClient {
    constructor(url) {
        this.httpSuccessResponseCode = 200;
        this.httpRedirectResponseCode = 300;
        this.url = url;
    }
    async get(url, options) {
        const prefixedUrl = this.addPrefixToUrl(url);
        const headers = this.buildHeaders(options);
        const request = {
            method: 'GET',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: headers,
        };
        const response = await (0, cross_fetch_1.default)(prefixedUrl, request);
        const parsedResponse = await this.evaluateResponse(response);
        return parsedResponse;
    }
    async post(url, data, options) {
        const prefixedUrl = this.addPrefixToUrl(url);
        const headers = this.buildHeaders(options);
        const request = {
            method: 'POST',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: headers,
            body: JSON.stringify(data),
        };
        const response = await (0, cross_fetch_1.default)(prefixedUrl, request);
        const parsedResponse = await this.evaluateResponse(response);
        return parsedResponse;
    }
    async put(url, data, options) {
        const prefixedUrl = this.addPrefixToUrl(url);
        const headers = this.buildHeaders(options);
        const request = {
            method: 'PUT',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: headers,
            body: JSON.stringify(data),
        };
        const response = await (0, cross_fetch_1.default)(prefixedUrl, request);
        const parsedResponse = await this.evaluateResponse(response);
        return parsedResponse;
    }
    async delete(url, options) {
        const prefixedUrl = this.addPrefixToUrl(url);
        const headers = this.buildHeaders(options);
        const request = {
            method: 'DELETE',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: headers,
        };
        const response = await (0, cross_fetch_1.default)(prefixedUrl, request);
        const parsedResponse = await this.evaluateResponse(response);
        return parsedResponse;
    }
    addPrefixToUrl(url) {
        return `${this.url}/${url}`;
    }
    buildHeaders(options) {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
        };
        if ((options === null || options === void 0 ? void 0 : options.headers) != undefined) {
            const optionHeaders = Object.keys(options.headers);
            for (const header of optionHeaders) {
                headers[header] = options.headers[header];
            }
        }
        return headers;
    }
    async evaluateResponse(response) {
        const body = await response.text();
        if (this.responseIsAnError(response)) {
            this.createAndThrowError(response.status, body);
        }
        const parsedResponse = {
            result: this.tryParseStringtoJson(body),
            status: response.status,
        };
        return parsedResponse;
    }
    responseIsAnError(response) {
        return response.status < this.httpSuccessResponseCode || response.status >= this.httpRedirectResponseCode;
    }
    createAndThrowError(statusCode, body) {
        var _a, _b;
        const deserializedError = (0, atlas_engine_sdk_1.deserializeJson)(body);
        if ((0, atlas_engine_sdk_1.isAtlasEngineError)(deserializedError)) {
            throw deserializedError;
        }
        // BPMN errors cannot be transmitted across http directly, because their status code need not be a valid HTTP code.
        // Instead, they will be attached as a "bpmnError" property to the error's additionalInformation property.
        if ((_a = deserializedError.additionalInformation) === null || _a === void 0 ? void 0 : _a.bpmnError) {
            const bpmnErrorInfo = deserializedError.additionalInformation.bpmnError;
            throw new atlas_engine_sdk_1.BpmnError(bpmnErrorInfo.name, bpmnErrorInfo.code, bpmnErrorInfo.message);
        }
        const customError = new atlas_engine_sdk_1.InternalServerError((_b = deserializedError.message) !== null && _b !== void 0 ? _b : 'Failed to execute request');
        customError.additionalInformation = deserializedError.additionalInformation;
        customError.code = statusCode;
        customError.stack = deserializedError.stack;
        throw customError;
    }
    tryParseStringtoJson(result) {
        try {
            return JSON.parse(result);
        }
        catch (error) {
            return result;
        }
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=HttpClient.js.map